import { createFileRoute } from '@tanstack/react-router'
import { LayoutGrid } from 'lucide-react'
import { OverviewScreen } from '@/screens/workspace/SCR-001-overview'

export const Route = createFileRoute('/_app/w/$ws/overview')({
  staticData: { screen: {"id":"SCR-001","title":"Overview","group":"Workspace","perm":"workspace.read","pin":true,"order":1,"description":"Headline numbers for this workspace and what needs your attention.", icon: LayoutGrid } },
  component: OverviewScreen,
})
